import { removeAccentsLowers, findPrograma } from '@portal-internet/core';
import clsx from 'clsx';
import BlocDeContinguts from 'components/3cat/BlocDeContinguts';
import { types } from 'components/3cat/Formats';
import Mosaic from 'components/3cat/Mosaic';
import Slider from 'components/3cat/Slider';
import Boto from 'components/ui/Boto';
import Icona from 'components/3cat/ui/Icona';
import { useData } from 'hooks/useData';
import { useLoading } from 'hooks/3cat/useLoading';
import { typesViewport, useViewport } from 'hooks/useViewport';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import { useEffect, useState, useRef } from 'react';
import styles from './cercador.module.scss';
import { setGlobalEvar } from '../Audiencies/audiencies-datalayer';

const _getAllProgrames = (programesTv, programesRadio) => {
    if (!programesTv || !programesRadio) return [];

    const mergeProgrames = [...programesTv, ...programesRadio];
    return mergeProgrames.sort((a, b) => (a.titol > b.titol ? 1 : -1));
};

const _getProgramesCercats = (cercaProgrames, tipologiaCerca, searchValue) => {
    if (searchValue.length === 0) return [];
    return cercaProgrames?.filter((item) => {
        return (
            (tipologiaCerca === '' || item.tipologia === tipologiaCerca) &&
            findPrograma(removeAccentsLowers(item.titol.toLowerCase()), removeAccentsLowers(searchValue.toLowerCase()))
        );
    });
};

const _getUrlCerca = (urlCerca, tipologiaCerca, searchValue) => {
    let tipologia = '';

    switch (tipologiaCerca) {
        case 'PTVC_PROGRAMA':
            tipologia = 'DTY_VIDEO_MM';
            break;
        case 'WCR_PROGRAMA':
            tipologia = 'WCR_AUDIO_MM';
            break;
        default:
            tipologia = 'DTY_VIDEO_MM,WCR_AUDIO_MM';
            break;
    }

    return urlCerca.replace('{{TEXT_CERCA}}', encodeURIComponent(searchValue)).replace('{{TIPOLOGIA_CERCA}}', tipologia);
};

const PotserBusques = (props) => {
    const { cerca, potserBusquesTv, potserBusquesRadio } = props;
    const { viewport } = useViewport();
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (potserBusquesTv && potserBusquesRadio) {
            let itemsProgrames = [];
            let numColumnes;

            switch (viewport) {
                case typesViewport.VP_MOBILE:
                    numColumnes = 2;
                    break;
                case typesViewport.VP_SMALL:
                    numColumnes = 4;
                    break;
                default:
                    numColumnes = 6;
                    break;
            }

            const potserBusquesTvTmp = [...potserBusquesTv];
            const potserBusquesRadioTmp = [...potserBusquesRadio];
            const numItemsTotals = potserBusquesTv.length + potserBusquesRadio.length;

            for (let i = 0; i < numItemsTotals; i++) {
                const posColumna = i % numColumnes;

                if (posColumna < numColumnes / 2) {
                    itemsProgrames = [...itemsProgrames, potserBusquesTvTmp.shift()];
                } else {
                    itemsProgrames = [...itemsProgrames, potserBusquesRadioTmp.shift()];
                }
            }

            setItems(itemsProgrames);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewport]);

    return (
        <>
            {!cerca && (
                <div data-testid='potser-busques'>
                    <h2 className={styles.subtitol}>Potser busques</h2>
                    <div className={styles.resultatItems}>
                        <Mosaic
                            items={items}
                            classNameMosaic='potserBusques'
                            format={types.POSTER}
                            numColumns='6'
                            hGap='16'
                            vGap='30'
                        />
                    </div>
                </div>
            )}
        </>
    );
};

const NoResult = (props) => {
    const { items, itemsProgrames } = props;
    return (
        <>
            {__isEmpty(items) && __isEmpty(itemsProgrames) && (
                <p className={styles.noResults} data-testid='cercador-no-resultats'>
                    No s&apos;han trobat resultats
                </p>
            )}
        </>
    );
};

const updateUrlQuery = (urlQuery, router) => {
    if (router && router.query) {
        const existingQuery = { ...router.query };
        if (router.query.debug === 'yes') {
            existingQuery.debug = 'yes';
            if (!urlQuery) {
                delete existingQuery.cerca;
            }
        }
        let newQuery = urlQuery;
        if (urlQuery || router.query.debug === 'yes') {
            newQuery = { ...existingQuery, ...urlQuery };
        }

        const url = {
            pathname: '/3cat/cercador/',
            query: newQuery
        };

        const pushOptions = { shallow: true };
        router.push(url, undefined, pushOptions);
    }
};

const ResultatCerca = (props) => {
    const { cerca, itemProgramesCercats, searchValue, urlCerca, tipologiaCerca, setTipologiaCerca } = props;
    const { isLoading, data: items, paginacio, getDades } = useData();
    const { setIsActiveLoading } = useLoading();
    const [divResultatsVideos, setDivResultatsVideos] = useState(<></>);
    const router = useRouter();

    useEffect(() => {
        if (searchValue.length >= 2) getDades(urlCerca);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlCerca]);

    useEffect(() => {
        if (searchValue.length >= 2) {
            updateUrlQuery({ cerca: encodeURIComponent(searchValue) }, router);
        }
        setGlobalEvar('eVar40', searchValue);
        setGlobalEvar('eVar41', paginacio.total_items);
        setDivResultatsVideos(
            !__isEmpty(items) && (
                <BlocDeContinguts
                    paginacio={paginacio}
                    items={items}
                    tipus='MOSAIC'
                    format={types.KEYFRAME}
                    url={urlCerca}
                    barraprogres={false}
                    mostrarNomPrograma={true}
                    showLogoPrograma={true}
                />
            )
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items]);

    useEffect(() => {
        setIsActiveLoading(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    const getAudioVideoButtons = () => {
        return (
            <div className={styles.iconesAudioVideo}>
                <Boto
                    estil='az'
                    text='TOT'
                    tag='button'
                    onClick={() => setTipologiaCerca('')}
                    className={tipologiaCerca === '' && styles.selected}
                />
                <Boto
                    estil='az'
                    icona='play_contorn_ple'
                    altIcona='icona play'
                    tag='button'
                    mida={24}
                    onClick={() => setTipologiaCerca('PTVC_PROGRAMA')}
                    className={tipologiaCerca === 'PTVC_PROGRAMA' && styles.selected}
                />
                <Boto
                    estil='az'
                    icona='auriculars_ple'
                    altIcona='icona auriculars'
                    tag='button'
                    mida={24}
                    onClick={() => setTipologiaCerca('WCR_PROGRAMA')}
                    className={tipologiaCerca === 'WCR_PROGRAMA' && styles.selected}
                />
            </div>
        );
    };

    return (
        <>
            {cerca && (
                <>
                    <div>{getAudioVideoButtons()}</div>
                    <NoResult items={items} itemsProgrames={itemProgramesCercats} />
                    <div data-testid='resultats-cerca'>
                        <Slider items={itemProgramesCercats} midaImatge='web_posterpetit' cercadorLayout={true} />
                        {divResultatsVideos}
                    </div>
                </>
            )}
        </>
    );
};

export default function Cercador(props) {
    const { urlCerca, potserBusquesTv, potserBusquesRadio, cercaProgramesTv, cercaProgramesRadio, requiredServices } = props;
    const cercaProgrames = _getAllProgrames(cercaProgramesTv, cercaProgramesRadio);
    const router = useRouter();
    const { viewport } = useViewport();
    const debounceTimer = 750;

    const [tipologiaCerca, setTipologiaCerca] = useState('');
    const [searchValue, setSearchValue] = useState(
        router.query['cerca'] !== undefined ? decodeURIComponent(router.query['cerca']) : ''
    );
    const [cerca, setCerca] = useState(router.query['cerca'] !== undefined);
    const [itemProgramesCercats, setItemProgramesCercats] = useState([]);
    const [urlItemsCerca, setUrlItemsCerca] = useState('');

    const stylesIcoCerca = clsx({
        [styles.icona]: true,
        [styles.hide]: cerca
    });
    const stylesBtnTanca = clsx({
        [styles.botoTanca]: true,
        [styles.hide]: !cerca
    });

    useEffect(() => {
        setItemProgramesCercats(_getProgramesCercats(cercaProgrames, tipologiaCerca, searchValue));
        setUrlItemsCerca(_getUrlCerca(urlCerca, tipologiaCerca, searchValue));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tipologiaCerca]);

    const updateCercaTimer = useRef(null);

    useEffect(() => {
        clearTimeout(updateCercaTimer.current);
        if (searchValue.length >= 2) {
            updateCercaTimer.current = setTimeout(() => {
                setCerca(true);
                setItemProgramesCercats(_getProgramesCercats(cercaProgrames, tipologiaCerca, searchValue));
                setUrlItemsCerca(_getUrlCerca(urlCerca, tipologiaCerca, searchValue));
            }, debounceTimer);
        } else {
            setGlobalEvar('eVar40', undefined);
            setGlobalEvar('eVar41', undefined);
            updateUrlQuery(null, router);
            setCerca(false);
        }

        return () => {
            clearTimeout(updateCercaTimer.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    if (!requiredServices?.areAllServicesAvailable) {
        return <></>;
    }

    const onResetCercador = () => {
        setSearchValue('');
    };

    const onChangeCercadorValue = ({ target }) => {
        setSearchValue(target.value);
    };

    return (
        <>
            <div className={styles.campDeCerca}>
                <div className={styles.iconaCerca}>
                    <Icona icona='cercador' alt='Cerca' className={stylesIcoCerca} />
                    <button className={stylesBtnTanca} onClick={onResetCercador}>
                        <Icona className={styles.icona} icona='tanca' alt='Esborra' />
                    </button>
                </div>
                <input
                    ref={(input) => input?.focus()}
                    type='search'
                    placeholder={
                        viewport === typesViewport.VP_MOBILE ? 'Què vols veure?' : 'Programes, pel·lícules, sèries, capítols ...'
                    }
                    value={searchValue}
                    aria-label='Cercador'
                    className={styles.inputCercador}
                    onChange={onChangeCercadorValue}
                    data-testid='cercador-input'
                />
            </div>
            <PotserBusques cerca={cerca} potserBusquesTv={potserBusquesTv} potserBusquesRadio={potserBusquesRadio} />
            <ResultatCerca
                cerca={cerca}
                itemProgramesCercats={itemProgramesCercats}
                urlCerca={urlItemsCerca}
                searchValue={searchValue}
                tipologiaCerca={tipologiaCerca}
                setTipologiaCerca={setTipologiaCerca}
            />
        </>
    );
}

Cercador.defaultProps = {
    requiredServices: 'cercador'
};
